import { Avatar, Chip, Grid, Rating } from "@mui/material";
import { database } from "configs/firebaseConfigs";
import { onValue, ref } from "firebase/database";
import { useIsMounted } from "hooks";
import { useOrdersData, useProducts } from "hooks/useDataFetch";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Chart from "react-apexcharts";
import MaterialTable from "@material-table/core";
import { muiTable } from "utils";
import { formatCurrency } from "@ashirbad/js-core";
import moment from "moment";
import { Edit } from "@mui/icons-material";

const ViewSupplierDetails = () => {
  const [supplier, setSupplier] = useState({});
  const [supplierProducts, setSupplierProducts] = useState([]);
  const [recentOrder, setRecentOrder] = useState([]);
  const [allSupplierOrders, setAllSupplierOrders] = useState([]);
  const { id } = useParams();
  const isMounted = useIsMounted();
  const products = useProducts();
  const ordersData = useOrdersData();

  const [supplierSalesData, setSupplierSalesData] = useState({
    labels: {
      chart: {
        id: "Suppliers-Sales-Chart",
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
    series: [
      {
        name: "Sales",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  useEffect(() => {
    if (isMounted.current) {
      onValue(ref(database, `suppliers/${id}`), (snap) => {
        if (snap.exists()) {
          let data = snap.val();
          data.id = id;
          setSupplier(data);
        }
      });
    }
  }, [id, isMounted]);

  useEffect(() => {
    if (isMounted?.current) {
      if (ordersData?.data && ordersData?.data.length > 0) {
        let dataArray = [];
        let sl = 1;

        ordersData?.data?.map((order) => {
          return order?.products?.map((orderedProduct) => {
            dataArray.push({
              ...order,
              supplierId: orderedProduct.supplierId,
              products: {
                ...orderedProduct,
              },
              sl: sl,
            });
            sl++;

            return dataArray;
          });
        });

        let thisSupplierOrder = dataArray
          .filter((item) => {
            return item?.supplierId === id;
          })
          .sort((a, b) => {
            return b.createdAt - a.createdAt;
          });

        setAllSupplierOrders(thisSupplierOrder);
        setRecentOrder(thisSupplierOrder?.slice(0, 10));
      }
    }
  }, [ordersData?.data, isMounted, id]);

  // console.log(recentOrder);

  useEffect(() => {
    if (isMounted.current) {
      if (products?.data) {
        const supplierProductData = products?.data?.filter((item) => {
          return item?.supplierId === id;
        });
        setSupplierProducts(supplierProductData);
      }
    }
  }, [id, products?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!allSupplierOrders?.length) {
        return;
      }

      let janSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Jan";
      });
      let febSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Feb";
      });
      let marchSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Mar";
      });
      let aprilSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Apr";
      });
      let maySales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "May";
      });
      let juneSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Jun";
      });
      let julySales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Jul";
      });
      let augSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Aug";
      });
      let septSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Sep";
      });

      let octSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Oct";
      });
      let novSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Nov";
      });
      let decSales = allSupplierOrders?.filter((item) => {
        return moment(item?.createdAt).format("MMM") === "Dec";
      });

      setSupplierSalesData({
        labels: {
          chart: {
            id: "Suppliers-Sales-Chart",
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
        },
        series: [
          {
            name: "Sales",
            data: [
              janSales?.length,
              febSales?.length,
              marchSales?.length,
              aprilSales?.length,
              maySales?.length,
              juneSales?.length,
              julySales?.length,
              augSales?.length,
              septSales?.length,
              octSales?.length,
              novSales?.length,
              decSales?.length,
            ],
          },
        ],
      });
    }
  }, [isMounted, allSupplierOrders]);

  //   console.log(supplier);
  //   console.log(supplierProducts);

  return (
    <main className="view-supplier-details-main">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={4}>
          <div className="w-100 flex-column justify-content-center align-items-center supplier-details-profile gap-1 ">
            <Avatar
              src={supplier?.image || supplier?.img}
              sx={{
                height: "8rem",
                width: "8rem",
              }}
            />
            <h3 className="supplier-details-h3">{supplier?.name}</h3>
            <span className="supplier-type">{supplier?.supplierType}</span>
          </div>
          <div className="flex-row w-100  justify-content-between align-items-center view-supplier-stat ">
            <span className="flex-column align-items-center justify-content-center">
              <span className="total-supplier-sale">
                {" "}
                {supplierProducts?.reduce((acc, item) => {
                  return acc + item?.totalSold;
                }, 0)}{" "}
              </span>
              Total sale
            </span>
            <span className="flex-column align-items-center justify-content-center">
              <span className="total-supplier-sale">
                {" "}
                {supplierProducts?.length}{" "}
              </span>
              Total Product
            </span>
            <span className="flex-column align-items-center justify-content-center">
              <span className="total-supplier-sale">
                SAR{" "}
                {supplierProducts?.reduce((acc, item) => {
                  return acc + item?.totalSold * item?.price;
                }, 0)}{" "}
              </span>
              Total Revenue
            </span>
          </div>
          <div className="w-100 supplier-reviews-rating ">
            <div className="flex-row align-items-center justify-content-between">
              <h3 className="supplier-details-h3">Rating and Reviews</h3>
              <Rating value={supplier?.rating || 0} />
            </div>
            <Link to={`/supplier/${id}`}>
              <span className="flex-row gap-1 align-items-center">
                {supplier?.reviews && supplier?.reviews + " Reviews"} <Edit />
              </span>
            </Link>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <div className="supplier-sale-stat">
            <div className="w-100">
              <div className="supplier-sale-stat-card">
                <span className="supplier-sale-stat-card-title">
                  Current Sales
                </span>
                <div className="w-100">
                  <Chart
                    options={supplierSalesData.labels}
                    series={supplierSalesData.series}
                    type="bar"
                    width={"100%"}
                    height={350}
                  />
                </div>
              </div>
              {/* <div className="supplier-sale-stat-card">
                <span className="supplier-sale-stat-card-title">
                  Orders Overview
                </span>
                <div className="w-100">
                  <Chart
                    options={pieChart}
                    series={pieChart.series}
                    type="pie"
                    width={"100%"}
                    height={360}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </Grid>
      </Grid>
      <div className="w-100 supplier-sale ">
        <MaterialTable
          title="Recent Orders"
          isLoading={ordersData?.loading}
          data={recentOrder || []}
          options={{ ...muiTable.options() }}
          style={muiTable.styles}
          columns={[
            {
              title: "#",
              field: "sl",
              width: "5%",
              editable: "never",
              id: "sl",
            },
            {
              title: "OrderID",
              field: "id",
            },
            {
              title: "Product Name",
              field: "products",
              render: (rowData) => {
                return rowData.products?.productName;
              },
            },
            {
              title: "Unit",
              field: "products",
              render: (rowData) => {
                return rowData.products?.orderedQty + " Unit";
              },
            },
            {
              title: "Ordered Date",
              field: "createdAt",
              type: "date",
              render: (rowData) => {
                return moment(parseInt(rowData?.createdAt)).format(
                  "DD-MMM-YYYY"
                );
              },
            },
            {
              title: "Order Price",
              field: "totalPrice",
              render: (rowData) => {
                return formatCurrency(rowData.products?.price);
              },
            },
            {
              title: "Supplier",
              field: "products",
              render: (rowData) => {
                return rowData?.products?.supplierName
                  ?.trim()
                  .replace(/^\w/, (c) => c.toUpperCase());
              },
            },
            {
              title: "Status",
              field: "status",
              render: (rowData) => {
                if (rowData.status === "pending") {
                  return (
                    <Chip color="primary" label="Pending" variant="outlined" />
                  );
                } else if (rowData.status === "processing") {
                  return (
                    <Chip
                      color="secondary"
                      label="Shipped"
                      variant="outlined"
                    />
                  );
                } else if (rowData.status === "delivered") {
                  return (
                    <Chip
                      color="success"
                      label="Delivered"
                      variant="outlined"
                    />
                  );
                } else if (rowData.status === "canceled") {
                  return (
                    <Chip color="error" label="Canceled" variant="outlined" />
                  );
                } else {
                  return (
                    <Chip
                      color="warning"
                      label="Processing"
                      variant="outlined"
                    />
                  );
                }
              },
            },
          ]}
        />
      </div>
    </main>
  );
};

export default ViewSupplierDetails;
